@if (!thumb) {
    <svg-icon class="svg" src="assets/logo/logo-icon.svg"></svg-icon>
}
@if (icon) {
    <div class="svg" [style.background-color]="iconBackground">
        <i class="{{ icon }}"></i>
    </div>
}

@if (safeThumb) {
    <img class="thumb" [src]="safeThumb" />
}
<div class="image" [class.loaded]="loaded" [class.loading]="loading" [style.background-image]="image"></div>

<img class="preload" [src]="imagePreload" [loading]="lazy ? 'lazy' : 'eager'" (load)="isLoaded()" />
<noscript>
    <div class="image" [style.background-image]="imageNoScript"></div>
</noscript>
@if (imageSourceText?.length > 0) {
    <div class="image-source">
        {{ imageSourceText }}
    </div>
}
